<div [hidden]="!showGadget" class="justify-content-lg-end gadget">
    <div class="title">
        <span translate>{{title}}</span>

    </div>
    <div class="pt-4 pl-2">
        <div class="card-element">
            <h4>{{cardNum}}</h4>
            <p translate>{{cardText}}</p>
        </div>
        <button type="button" class="btn btn-primary" (click)="onBtnClick()">{{btnText | translate}}</button>
    </div>
</div>
